Ext.define('SA.view.OpenProjectMenu', {
    alias: 'widget.open-project-menu',
    extend: 'Ext.menu.Menu',

    cls: 'sa-open-project-menu',

    afterHide() {
        this.callParent(arguments);

        setTimeout(this.destroy.bind(this), 100);
    },

    beforeShow() {
        var projects = SA.data.Projects.getAllByLastViewed();

        Ext.suspendLayouts();

        this.updateHeight();

        this.callParent();

        this.removeAll();

        this.add(projects.map(project => {
            return {
                xtype: 'open-project-menu-item',
                project
            };
        }));

        Ext.resumeLayouts(true);

        this.mon(SA.Viewport, 'resize', this.updateHeight, this);
    },

    updateHeight() {
        this.maxHeight = Ext.dom.Element.getViewportHeight() * 0.75;
        this.updateLayout();
    }
});

Ext.define('SA.view.OpenProjectMenu.Item', {
    alias: 'widget.open-project-menu-item',
    extend: 'Ext.Component',

    cls: 'sa-open-project-menu-item',
    overCls: 'sa-open-project-menu-item-hover',

    tpl: [
        '<div class="sa-open-project-menu-item-name">{name:htmlEncode}</div>',
        '<div class="sa-open-project-menu-item-details">Last updated {date:date("l, F j, Y")}</div>'
    ],

    initComponent() {
        var project = this.project;

        this.data = {
            date: new Date(project.getUpdatedTime() * 1000),
            name: project.getName()
        };

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onClick, this);
    },

    onClick() {
        SA.AppController.openProject(this.project);

        this.up('open-project-menu').hide();
    }
});